//The purpose of this component is to wrap buttons that initiate calls to the backend, such that it can display success or error messages,
// thus providing better feedback to users.
import React, {useEffect, useState} from "react";

const ClientComponent = ({sendData, callback, buttonTitle, showSuccessMessage, errorCallback}) => {
    const [success, setSuccess] = useState(null)
    const [fetched, setFetched] = useState(false)
    const [successMessage, setSuccessMessage] = useState(null)
    const [failureMessage, setFailureMessage] = useState(null)
    const shouldShowSuccessMessage = showSuccessMessage !== false

    //In many cases we are retrieving data to show to the user, so we might not wanna show a success message on top
    //However, we will always wanna show an error message
    const handleBackendCall = () => {
        setFetched(false)
        sendData()
            .then((response) => {
                callback && callback(response)
                setFetched(true);
                setSuccess(true);
                if(shouldShowSuccessMessage) {
                    setSuccessMessage(response.data?.successMsg ? response.data.successMsg : "Success")
                }
            })
            .catch((error) => {
                errorCallback && errorCallback(errorCallback);
                setFetched(true);
                setSuccess(false);
                console.error("Request failed: ", error);
                //This is kinda ugly - but one handles the errors we get from the backend, and the other handles direct errors thrown in frontend
                if(error.response?.data?.message) {
                    setFailureMessage(error.response.data.message)
                } else {
                    setFailureMessage(error.message ? error.message : "Failed")
                }
            });
    }

    return (<div style={{marginTop: '1rem'}}>
            <button onClick={handleBackendCall}>{buttonTitle}</button>
            {fetched && (success ?
                shouldShowSuccessMessage && <div className="info-message success"
                     style={{width: "fit-content", padding: "1rem", marginTop: "0.5rem"}}>
                    {successMessage}
                </div> :
                <div className="info-message error"
                     style={{width: "fit-content", padding: "1rem", marginTop: "0.5rem"}}>
                    {failureMessage}
                </div>)
            }

        </div>

    )
}

export default ClientComponent;